// src/pages/Departments/Pashu.js
export default function Pashu() {
  return (
    <div>
      <h2>पशुसंवर्धन विभाग</h2>
      <p>
        पशुपालन, दुग्धोत्पादन, पशुवैद्यकीय सेवा आणि
        शेतकऱ्यांना पशुधनासाठी उपलब्ध योजना.
      </p>
    </div>
  );
}
